import {
  Button,
  Grid,
  IconButton,
  Typography,
  Box,
  Checkbox,
  Tooltip,
  CardMedia,
} from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {
  Applicant,
  ApplicationProps,
  coparcenersType,
  Document,
  Groups,
  individuals_Poa_nonIndividuals_Documents,
  PromotersAndPartnersType,
} from '../../redux-store/types/api-types';
import {
  grossAnnualIciciMasters,
  grossAnnualMasters,
  investorTypeMasters,
  investorTypeMastersForKotak,
  NON_REPEATED_RELATIONS,
  PEPsMasters,
  Relations,
  SAVE_LATER_VALIDATION_CHECK,
} from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  checkIfApplicationIsNonIndividual,
  checkInvestorTypeChanged,
  checkKartaUpdated,
  currencyConversion,
  getAuthorisedSignatoryBasedOnKarta,
  updateGroupSignatoriesWithKarta,
  getFirstErrorField,
  getStep,
  isCustodianKotak,
  isHufType,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
  scrollToFieldByName,
  shouldValidateUponSaveLater,
  isCustodianICICI,
} from '../../utils/utilityFunctions';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { getDocuments, updateApplication } from '../../redux-store/actions/application';
import {
  NonIndividualContributorValidationSchema,
  nonIndividualCoparceres,
  nonIndividualParners,
} from '../../utils/schema';
import { useSnackbar } from 'notistack';
import FieldValidationNote from '../investors/FieldValidationNote';
import { nonDigitRegex } from '../../utils/regex';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { formatShortDate } from '../../utils/date';
import { DataTable } from '../DataTable';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { FileUpload } from './DocumentDetails';
import { documentDetails } from '../investors/documentDetails';
import { AccessibleDialog } from '../../lib/AccessibleDialog';

type UpdatedApplicant = Partial<Applicant & { otherSourceOfFunds: string }>;

const contributorObject: Partial<Applicant> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '',
  netWorth: '',
};

export const coparcenersListingObject: coparcenersType = {
  relation: '',
  karta: false,
  name: '',
  pan: '',
  mobile: '',
  dob: '',
  relationShipOthers: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  email: '',
  designation: '',
  address1: '',
  address2: '',
  country: '',
  state: '',
  pincode: '',
  city: '',
  isActive: true,
  aadharNumber: '',
};

export const promotersAndPartnersListingObject: PromotersAndPartnersType = {
  relation: '',
  name: '',
  pan: '',
  mobile: '',
  dateOfBirth: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  email: '',
  isActive: true,
  country: '',
  state: '',
  pincode: '',
  city: '',
  address1: '',
  address2: '',
  designation: '',
  promoterdocuments: [],
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: UpdatedApplicant[];
  coparceners: coparcenersType[];
  promoters: PromotersAndPartnersType[];
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  coparceners: [],
  promoters: [],
};
export const viewPartnersDownloadCell = (docData: documentDetails[], widthFit?: boolean): any => {
  return docData.map((_doc_data) => {
    return {
      header: _doc_data.documentName,
      renderEditDeleteCell: (row: PromotersAndPartnersType): JSX.Element => {
        const docDataFilter =
          row.promoterdocuments?.length > 0 &&
          row.promoterdocuments.filter((_data) => _data.documentType === _doc_data.documentType)
            ?.length > 0;
        return (
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'flex-start', md: 'center' },
                width: widthFit ? 'fit-content' : '100%',
              }}>
              {docDataFilter ? (
                row.promoterdocuments
                  .filter((_data) => _data.documentType === _doc_data.documentType)
                  .map((rowData) => {
                    const fileData = rowData?.file || rowData?.fileView;
                    {
                      return fileData?.id ? (
                        <>
                          {fileData?.viewUrl && (
                            <Tooltip title="View">
                              <IconButton onClick={() => window.open(fileData?.viewUrl, '_blank')}>
                                <RemoveRedEyeIcon />
                              </IconButton>
                            </Tooltip>
                          )}

                          {fileData?.url && (
                            <Tooltip title="Download">
                              <IconButton
                                sx={{
                                  p: 0,
                                  pr: 0.5,
                                  ':hover': {
                                    bgcolor: '#F4FCFC',
                                  },
                                  cursor: 'pointer',
                                  pointerEvents: 'all',
                                  mb: 1,
                                }}
                                onClick={() => window.open(fileData?.url, '_blank')}>
                                <CardMedia
                                  component="img"
                                  src={'/images/download-icon.png'}
                                  alt="Download"
                                  sx={{ width: '25px' }}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      ) : (
                        <Typography component="span"> N/A</Typography>
                      );
                    }
                  })
              ) : (
                <Typography component="span">N/A</Typography>
              )}
            </Box>
          </>
        );
      },
    };
  });
};
export const getPartnersDocuments = (
  response: Document | null,
  partnersDoc: PromotersAndPartnersType
): documentDetails[] => {
  return (
    (
      (response?.non_individual_partners as unknown as individuals_Poa_nonIndividuals_Documents[]) ||
      []
    ).map((responseData) => {
      const checkParnersDoc =
        partnersDoc.promoterdocuments &&
        partnersDoc.promoterdocuments?.length > 0 &&
        partnersDoc.promoterdocuments?.filter(
          (doc) => doc.documentType === responseData.documentType
        )?.length > 0;
      if (checkParnersDoc) {
        return partnersDoc.promoterdocuments
          .reduce((acc: documentDetails[], groupData) => {
            if (groupData.documentType === responseData.documentType) {
              const { required, multipleFiles, ...rest } = responseData;
              acc.push({
                ...groupData,
                required: required,
                multipleFiles,
                errorOnUpload: false,
              });
            }
            return acc;
          }, [])
          .flat();
      } else {
        return {
          ...responseData,
          required: responseData.required,
          documentId: '',
          isActive: true,
          errorOnUpload: false,
        };
      }
    }) as documentDetails[]
  ).flat();
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [pramotorsDocData, setPramotorsDocData] = useState<documentDetails[]>([]);
  const [contributorValuesAndParners, setContributorAndParnersValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [validationDialog, setValidationDialog] = useState({ open: false, message: '' });

  const validateCoparceners = (values: Values): string | null => {
    if (
      isHufType(values.applicants || []) &&
      checkIfApplicationIsNonIndividual(application as ApplicationProps) &&
      values.saveType === 'save and proceed'
    ) {
      const { coparceners = [] } = values;
      const alreadySelectedRelations = coparceners
        ?.filter((item) => item.isActive)
        .map((coparcener) => coparcener.relation);
      const repeatedRelations = alreadySelectedRelations.filter(
        (relation, index) => alreadySelectedRelations.indexOf(relation) !== index
      );
      const activeCoparcenersCount = coparceners?.filter((item) => item.isActive).length;
      const kartaCount = coparceners?.filter((item) => item.isActive && item.karta).length;

      if (!activeCoparcenersCount) {
        return 'Please Add Coparceners';
      }
      if (kartaCount > 1) {
        return 'There can be only one Karta';
      }
      if (kartaCount === 0) {
        return 'Please select Karta';
      }

      for (const relation of repeatedRelations) {
        if (NON_REPEATED_RELATIONS.includes(relation)) {
          return `There can be only one coparcener with the relation - ${relation}`;
        }
      }
    }
    return null;
  };

  const validatepartners = (values: Values): string | null => {
    if (
      !isHufType(values.applicants || []) &&
      checkIfApplicationIsNonIndividual(application as ApplicationProps) &&
      values.saveType === 'save and proceed'
    ) {
      const { promoters = [] } = values;

      const activeCoparcenersCount = promoters?.filter((item) => item.isActive).length;

      if (!activeCoparcenersCount) {
        return 'Please Add Promoters / Partners / Trustees';
      }
    }
    return null;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { applicants = [], coparceners = [], promoters = [] } = application || {};
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;

        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const response = (await dispatch(getDocuments())) as unknown as Document;
        const pramotorsData = (
          (response?.non_individual_partners as unknown as individuals_Poa_nonIndividuals_Documents[]) ||
          []
        ).map((_doc) => {
          return { ..._doc, documentId: '', isActive: true, errorOnUpload: false };
        });
        setPramotorsDocData(pramotorsData);

        setContributorAndParnersValues((prev) => ({
          ...prev,
          applicants: applicants.length ? applicants : [contributorObject],
          coparceners: coparceners.length ? coparceners : [],
          promoters: (promoters.length ? promoters : []).map((_partnersMap) => ({
            ..._partnersMap,
            promoterdocuments: getPartnersDocuments(response, _partnersMap),
          })),
        }));
      } catch (e) {
        console.error((e as Error).message);
      }
    };

    fetchData();
  }, [application]);

  const handleCoparceners = async (values: Values) => {
    const { saveType, applicants = [], coparceners = [] } = values;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const isSaveLater = saveType !== 'save and proceed';
    const getDeactivatedAuthorisedSignatories = application?.groups.map((group) => {
      return { ...group, isActive: false };
    }) as Groups[];

    const coparcenersData = (values.coparceners || []).map((item) => {
      if (item?.karta) {
        return { ...item, designation: 'Karta', karta: item?.karta };
      } else {
        return item;
      }
    });

    const partnersData = values.promoters.map((item) => {
      return { ...item, isActive: false };
    });

    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        coparceners:
          isHufType(applicants || []) &&
          checkIfApplicationIsNonIndividual(application as ApplicationProps)
            ? coparceners.map((coparceners) => {
                return {
                  ...coparceners,
                  name: removeSingleQuote(coparceners.name),
                  // designation: removeSingleQuote(coparceners.designation),
                  designation: coparceners?.karta
                    ? 'Karta'
                    : removeSingleQuote(coparceners.designation) || '',
                  email: removeSingleQuote(coparceners.email),
                };
              })
            : coparceners.map((coparcener) => {
                return { ...coparcener, isActive: false };
              }),
        promoters: partnersData,
        groups:
          isHufType(applicants || []) &&
          checkIfApplicationIsNonIndividual(application as ApplicationProps)
            ? application?.groups.length
              ? !checkKartaUpdated(values.coparceners, application.coparceners)
                ? updateGroupSignatoriesWithKarta(application.groups, coparcenersData)
                : application.groups
              : getAuthorisedSignatoryBasedOnKarta(coparcenersData)
            : application?.groups,
        modeOfHolding: 'single',
        currentStep: getStep(
          !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
          isSaveLater
        ),
      }
    );

    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
            })),
            coparceners:
              isHufType(applicants || []) &&
              checkIfApplicationIsNonIndividual(application as ApplicationProps)
                ? coparceners.map((coparceners) => {
                    return {
                      ...coparceners,
                      name: removeSingleQuote(coparceners.name),
                      designation: coparceners?.karta
                        ? 'Karta'
                        : removeSingleQuote(coparceners.designation) || '',
                      email: removeSingleQuote(coparceners.email),
                      address1: removeSingleQuote(coparceners.address1) || '',
                      address2: removeSingleQuote(coparceners.address2) || '',
                      city: removeSingleQuote(coparceners.city) || '',
                      state: removeSingleQuote(coparceners.state) || '',
                      country: removeSingleQuote(coparceners.country) || '',
                      pincode: removeSingleQuote(coparceners.pincode) || '',
                    };
                  })
                : coparceners.map((coparcener) => {
                    return { ...coparcener, isActive: false };
                  }),
            modeOfHolding: 'single',
            promoters: partnersData,
            currentStep: getStep(2, isSaveLater),
            ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
            groups:
              isHufType(applicants || []) &&
              checkIfApplicationIsNonIndividual(application as ApplicationProps)
                ? application?.groups.length
                  ? !checkKartaUpdated(values.coparceners, application.coparceners)
                    ? updateGroupSignatoriesWithKarta(application.groups, coparcenersData)
                    : application.groups
                  : getAuthorisedSignatoryBasedOnKarta(coparcenersData)
                : checkInvestorTypeChanged(application, values)
                ? getDeactivatedAuthorisedSignatories
                : application?.groups,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          // ...(saveType !== 'save and proceed' && {
          //   toastMessage: '',
          // }),
        })
      );
    }
  };

  const handlePramoters = async (values: Values) => {
    const { saveType, applicants = [], promoters = [] } = values;
    const { id, currentStep, banks = [] } = application || {};
    const getDeactivatedAuthorisedSignatories = application?.groups.map((group) => {
      return { ...group, isActive: false };
    }) as Groups[];
    const isSaveLater = saveType !== 'save and proceed';

    const coparcenersData = values.coparceners.map((item) => {
      return { ...item, isActive: false };
    });

    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        promoters:
          !isHufType(applicants || []) &&
          checkIfApplicationIsNonIndividual(application as ApplicationProps)
            ? promoters.map((_pramotors) => {
                return {
                  ..._pramotors,
                  name: removeSingleQuote(_pramotors.name),
                  email: removeSingleQuote(_pramotors.email),
                  promoterdocuments: _pramotors?.promoterdocuments?.map((item) => {
                    const { errorOnUpload, required, multipleFiles, ...rest } = item;
                    return { ...rest };
                  }),
                };
              })
            : promoters.map((_pramotors) => {
                return { ..._pramotors, isActive: false };
              }),
        coparceners: coparcenersData,
        modeOfHolding: 'single',
        currentStep: getStep(
          !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
          isSaveLater
        ),
      }
    );

    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
            })),
            promoters:
              !isHufType(applicants || []) &&
              checkIfApplicationIsNonIndividual(application as ApplicationProps)
                ? promoters.map((_pramotors) => {
                    return {
                      ..._pramotors,
                      name: removeSingleQuote(_pramotors.name),
                      email: removeSingleQuote(_pramotors.email),
                      promoterdocuments: _pramotors?.promoterdocuments?.map((item) => {
                        const { errorOnUpload, required, multipleFiles, ...rest } = item;
                        return { ...rest };
                      }),
                    };
                  })
                : promoters.map((_pramotors) => {
                    return { ..._pramotors, isActive: false };
                  }),
            coparceners: coparcenersData,
            modeOfHolding: 'single',
            groups:
              application?.groups?.map((group) => ({
                ...group,
                groupsignatories: group?.groupsignatories?.map((_item) => {
                  return { ..._item, isActive: _item.karta ? false : _item.isActive };
                }),
              })) || [],
            currentStep: getStep(2, isSaveLater),
            ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
          },
          applicationId: id,
        })
      );
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);

      const validationError = isHufType(values.applicants)
        ? validateCoparceners(values)
        : validatepartners(values);
      if (validationError) {
        setValidationDialog({ open: true, message: validationError });
        setLoading(false);
        return;
      }

      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      isHufType(values.applicants) ? await handleCoparceners(values) : handlePramoters(values);
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  const investorTypeMasterForCurrentCustodian = isCustodianKotak(application?.custodian || '')
    ? investorTypeMastersForKotak
    : investorTypeMasters;

  const headers = [
    {
      header: 'Name',
      label: 'name',
      valueGetter: (row: coparcenersType) => row.name || 'N/A',
    },
    {
      header: 'Relation',
      valueGetter: (row: coparcenersType) =>
        row.relation === 'Others' ? row.relationShipOthers : row.relation || 'N/A',
    },
    {
      header: 'Date of Birth',
      valueGetter: (row: coparcenersType) =>
        (row.dob ? formatShortDate(new Date(row.dob)) : 'N/A') || 'N/A',
    },
  ];

  const partnersHeaders = [
    {
      header: 'Name',
      label: 'name',
      valueGetter: (row: PromotersAndPartnersType) => row.name || 'N/A',
    },
    {
      header: 'Designation',
      valueGetter: (row: PromotersAndPartnersType) =>
        row.relation === 'Others' ? row.designation : row.designation || 'N/A',
    },
    {
      header: 'Date of Birth',
      valueGetter: (row: PromotersAndPartnersType) =>
        (row.dateOfBirth ? formatShortDate(new Date(row.dateOfBirth)) : 'N/A') || 'N/A',
    },
  ];

  function CoparceresDetails({
    coparcenersValues,
    nationalitiesMdmsResponse,
  }: {
    coparcenersValues: Values;
    nationalitiesMdmsResponse: mdmsCountriesList[];
  }): JSX.Element {
    const [open, setOpen] = useState(false);
    const [coparcenersListing, setCoparceresListing] = useState(coparcenersListingObject);
    const [rowIndex, setRowIndex] = useState(Number);
    const [deletePopup, setDeletePopup] = useState(false);
    const handleClose = () => {
      setCoparceresListing(coparcenersListingObject);
      setRowIndex(Number);
      setOpen(false);
    };

    const onSubmit = (values: coparcenersType) => {
      const editcoparceners = coparcenersValues.coparceners
        .filter((_item) => _item.isActive)
        .map((_coparceners, ind) => {
          if (ind === rowIndex) {
            return {
              ...values,
            };
          }
          return { ..._coparceners, isFetchData: false };
        });
      const deletedcoparcenerss = coparcenersValues.coparceners.filter(
        (_item) => !_item.isActive && _item.id
      );
      setContributorAndParnersValues({
        ...coparcenersValues,
        coparceners:
          coparcenersListing.email === ''
            ? [
                ...coparcenersValues.coparceners,
                {
                  ...values,
                  isActive: true,
                },
              ]
            : [...editcoparceners, ...deletedcoparcenerss],
      });
      handleClose();
    };

    const sendToEsignCell = {
      header: (): JSX.Element => {
        const [open, setOpen] = useState(false);

        const handleOpen = () => {
          setOpen(true);
        };
        const handleClose = () => {
          setOpen(false);
        };
        return (
          <>
            <Typography
              variant="h6"
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: 14,
                fontWeight: 500,
                color: 'primary.main',
                pr: 0.5,
              }}
              component="span">
              Karta
            </Typography>
            <InfoOutlinedIcon
              color="info"
              fontSize="small"
              onClick={handleOpen}
              sx={{ position: 'relative', top: 4 }}
            />
            <AccessibleDialog
              onClose={handleClose}
              open={open}
              sx={{
                '.MuiPaper-root ': {
                  maxWidth: 400,
                  p: { xs: 2, sm: '15px 20px 45px' },
                  borderRadius: '10px',
                  height: 'unset',
                  overflowY: 'auto',
                },
              }}>
              <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="medium" />
              </IconButton>
              <Box
                sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
                <InfoOutlinedIcon color="info" fontSize="large" />
              </Box>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 20,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography component="span" sx={{ color: 'secondary.main', lineHeight: '35px' }}>
                  Use this option to set Karta.
                </Typography>
              </Box>
            </AccessibleDialog>
          </>
        );
      },
      renderEditDeleteCell: (row: coparcenersType, index: number): JSX.Element => {
        return (
          <Checkbox
            checked={row.karta}
            sx={{ display: { xs: 'block' }, ':hover': { backgroundColor: 'white' } }}
            onChange={() => {
              const activeCoparceners = contributorValuesAndParners.coparceners.filter(
                (_item) => _item.isActive
              );
              const coparcenerToUpdate = activeCoparceners[index];

              const updatedCoparceners = contributorValuesAndParners.coparceners.map(
                (_coparcener) => {
                  if (coparcenerToUpdate.id && _coparcener.id === coparcenerToUpdate.id) {
                    return { ..._coparcener, karta: !_coparcener.karta };
                  } else if (!coparcenerToUpdate.id && _coparcener === coparcenerToUpdate) {
                    return { ..._coparcener, karta: !_coparcener.karta };
                  }
                  return _coparcener;
                }
              );

              setContributorAndParnersValues({
                ...contributorValuesAndParners,
                coparceners: updatedCoparceners,
              });
              setCoparceresListing(coparcenersListingObject);
              setRowIndex(Number);
            }}
          />
        );
      },
    };

    const editCell = {
      header: '',
      renderEditDeleteCell: (row: coparcenersType, index: number): JSX.Element => {
        return (
          <Box display="flex">
            <Tooltip aria-label="Edit Coparcener" title="Edit Coparcener">
              <IconButton
                onClick={() => {
                  setCoparceresListing({
                    ...row,
                  }),
                    setRowIndex(index),
                    setOpen(true);
                }}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}>
                <EditIcon sx={{ color: 'primary.main' }} fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip aria-label="Delete Coparcener" title="Delete Coparcener">
              <IconButton
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}
                onClick={() => {
                  setCoparceresListing(row), setRowIndex(index), setDeletePopup(true);
                }}>
                <DeleteOutlineIcon color="error" fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    };

    return (
      <>
        {coparcenersValues.coparceners.filter((_item) => _item.isActive).length !== 0 && (
          <Grid xs={12} sm={12} lg={12} mt={3}>
            <DataTable
              tableData={coparcenersValues.coparceners.filter((_item) => _item.isActive)}
              tableHeader={[sendToEsignCell, ...headers, editCell]}
              renderAdditionalRow={false}
              tableHeaderCustomStyles={{
                '.MuiTableCell-head': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'primary.main',
                },
              }}
              rowCustomStyles={{
                '.MuiTableCell-root': {
                  py: '8px',
                  overflowWrap: 'anywhere',
                },
              }}
              boxStyles={{ minHeight: '0px', minWidth: 450 }}
            />
          </Grid>
        )}
        <Grid
          xs={12}
          sm={12}
          lg={12}
          display="flex"
          sx={{
            justifyContent: {
              xs:
                coparcenersValues.coparceners.filter((_item) => _item.isActive).length === 0
                  ? 'start'
                  : 'center',
              sm:
                coparcenersValues.coparceners.filter((_item) => _item.isActive).length === 0
                  ? 'start'
                  : 'end',
            },
          }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{
              color: 'primary.main',
              fontWeight: 500,
              fontSize: 13,
              mr: 2.5,
              whiteSpace: 'nowrap',
              mt: '20px',
            }}
            onClick={() => {
              setCoparceresListing(coparcenersListingObject), setOpen(true);
            }}>
            Add Coparcener
          </Button>

          <AccessibleDialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                px: 1,
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                position: 'sticky',
                top: 0,
                boxShadow: '0 2px #ccc 0.6',
                zIndex: 10,
                bgcolor: 'white',
                py: 3,
              }}>
              <Typography
                component="h3"
                sx={{
                  color: '#0D2762',
                  fontSize: '20px',
                  fontWeight: 500,
                  ml: { xs: 2, sm: 5 },
                }}>
                {coparcenersListing.email ? 'Edit Coparcener Details' : 'Add Coparcener Details'}
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '90%' },
                mx: 'auto',
                px: { xs: 3, sm: 0 },
                pb: 4,
              }}>
              <Formik
                initialValues={coparcenersListing}
                onSubmit={onSubmit}
                validate={(values: coparcenersType) => {
                  const setValuesForEdit = contributorValuesAndParners.coparceners
                    .filter((_item) => _item.isActive)
                    .map((_coparceners, index) => {
                      if (index === rowIndex) {
                        if (
                          values.pan !== _coparceners.pan &&
                          values.mobile !== _coparceners.mobile &&
                          values.email !== _coparceners.email
                        ) {
                          return _coparceners;
                        }
                        if (
                          values.pan === _coparceners.pan &&
                          values.mobile === _coparceners.mobile &&
                          values.email === _coparceners.email
                        ) {
                          const { mobile, email, pan, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        if (
                          values.pan !== _coparceners.pan &&
                          values.mobile === _coparceners.mobile &&
                          values.email === _coparceners.email
                        ) {
                          const { mobile, email, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        if (
                          values.pan === _coparceners.pan &&
                          values.mobile !== _coparceners.mobile &&
                          values.email === _coparceners.email
                        ) {
                          const { pan, email, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        if (
                          values.pan === _coparceners.pan &&
                          values.mobile === _coparceners.mobile &&
                          values.email !== _coparceners.email
                        ) {
                          const { mobile, pan, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        if (
                          values.pan !== _coparceners.pan &&
                          values.mobile !== _coparceners.mobile &&
                          values.email === _coparceners.email
                        ) {
                          const { email, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        if (
                          values.pan !== _coparceners.pan &&
                          values.mobile === _coparceners.mobile &&
                          values.email !== _coparceners.email
                        ) {
                          const { mobile, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        if (
                          values.pan === _coparceners.pan &&
                          values.mobile !== _coparceners.mobile &&
                          values.email !== _coparceners.email
                        ) {
                          const { pan, ...rest } = _coparceners;
                          return { ...rest };
                        }
                        return;
                      }
                      return _coparceners;
                    });
                  try {
                    validateYupSchema(
                      values,
                      nonIndividualCoparceres(
                        nationalitiesMdmsResponse?.map((list) => {
                          return list?.name;
                        })
                      ),
                      true,
                      coparcenersListing.email
                        ? setValuesForEdit
                        : contributorValuesAndParners.coparceners.filter((_item) => _item.isActive)
                    );
                  } catch (e) {
                    return yupToFormErrors(e);
                  }
                }}
                enableReinitialize={true}>
                {({ handleSubmit, setFieldValue, values, errors }) => (
                  <Grid
                    container
                    rowSpacing={1}
                    sx={{
                      width: '100%',
                      ml: 0,
                      '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                      mt: 1,
                    }}
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}>
                    <Grid item xs={12}>
                      <MFTextField name={`name`} label="Name *" placeholder="Enter Name" />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`pan`}
                        label="PAN *"
                        placeholder="Enter Pan"
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                        onChange={(e) => {
                          setFieldValue('pan', e.target.value.toUpperCase());
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <DatePicker
                        label={'Date of Birth *'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'rgba(0,0,0,0.7)',
                        }}
                        placeholder={'DD/MM/YYYY'}
                        name={`dob`}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`mobile`}
                        label={`Mobile Number *`}
                        placeholder="Enter Mobile Number"
                        onKeyDown={(e) => {
                          preventSpecialCharacters(e);
                        }}
                        startAdornment={
                          <CountryCodesDropDown
                            name={`countryNameAndCode`}
                            value={values.countryNameAndCode}
                          />
                        }
                        regexForFilterValue={nonDigitRegex}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`email`}
                        label="Email ID (Office ID Only) *"
                        placeholder="Enter Email ID"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <MFSelectField
                        name={`relation`}
                        label="Relationship *"
                        items={Relations.map((relation) => ({
                          key: relation,
                          value: relation,
                        }))}
                      />
                    </Grid>
                    {values.relation === 'Others' && (
                      <Grid item xs={12}>
                        <MFTextField
                          name={`relationShipOthers`}
                          label="Please Specify Relationship *"
                          placeholder={`Enter Relationship`}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <MFTextField
                        name={`aadharNumber`}
                        label="Aadhar Last 4 Digit *"
                        placeholder="Enter last 4 digits"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <MFTextField
                        name={`address1`}
                        label="Address Line - 1 *"
                        placeholder="Enter Address Line - 1"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`address2`}
                        label="Address Line - 2 *"
                        placeholder="Enter Address Line - 2"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <SearchableSelect
                        name={`country`}
                        label="Country *"
                        items={nationalitiesMdmsResponse.map((nationality) => ({
                          key: nationality.name,
                          value: nationality.name,
                        }))}
                        searchFieldPlaceholder={'Search Country'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MFTextField name={`state`} label="State *" placeholder="Enter State" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MFTextField name={`city`} label="City *" placeholder="Enter City" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MFTextField name={`pincode`} label="Pincode *" placeholder="Enter Pincode" />
                    </Grid>

                    <Grid xs={12} sm={12} lg={12} display="flex" sx={{ justifyContent: 'center' }}>
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: 15,
                          minWidth: 180,
                          letterSpacing: 2,
                          fontWeight: 500,
                          alignSelf: 'center',
                          mt: 2,
                        }}
                        type="submit">
                        {coparcenersListing.email ? 'Save' : 'Add'}
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            </Box>
          </AccessibleDialog>
          <ConfirmationDialog
            message={'Are you sure you want to delete Coparcener ?'}
            open={deletePopup}
            setOpen={() => setDeletePopup(false)}
            onSave={() => {
              setDeletePopup(false);
              const deletecoparceners = contributorValuesAndParners.coparceners
                .filter((_item) => _item.isActive)
                .map((_coparceners, _ind) => {
                  if (rowIndex === _ind) {
                    return { ..._coparceners, isActive: false };
                  }
                  return _coparceners;
                });
              const deletedcoparcenerss = contributorValuesAndParners.coparceners.filter(
                (_item) => !_item.isActive && _item.id
              );
              const active_Deletedcoparcenerss = deletecoparceners.filter(
                (_item) => _item.isActive || (!_item.isActive && _item.id)
              );
              setContributorAndParnersValues({
                ...contributorValuesAndParners,
                coparceners: [...active_Deletedcoparcenerss, ...deletedcoparcenerss],
              });
              setCoparceresListing(coparcenersListingObject);
              setRowIndex(Number);
            }}
            onCancel={() => {
              setCoparceresListing(coparcenersListingObject);
              setRowIndex(Number);
              setDeletePopup(false);
            }}
          />
        </Grid>
      </>
    );
  }
  function PromotersAndPartners({
    PromotersAndPartnersValues,
    nationalitiesMdmsResponse,
    pramotorsDocData,
  }: {
    PromotersAndPartnersValues: Values;
    nationalitiesMdmsResponse: mdmsCountriesList[];
    pramotorsDocData: documentDetails[];
  }): JSX.Element {
    const [open, setOpen] = useState(false);

    const partnersData = {
      ...promotersAndPartnersListingObject,
      promoterdocuments: pramotorsDocData,
    };
    const [partnersListing, setPartnersListing] = useState(partnersData);
    const [rowIndex, setRowIndex] = useState(Number);
    const [deletePopup, setDeletePopup] = useState(false);
    const handleClose = () => {
      setPartnersListing({
        ...partnersData,
      });
      setRowIndex(Number);
      setOpen(false);
    };

    const onSubmit = (values: PromotersAndPartnersType) => {
      const editpramotors = PromotersAndPartnersValues.promoters
        .filter((_item) => _item.isActive)
        .map((_pramotors, ind) => {
          if (ind === rowIndex) {
            return {
              ...values,
            };
          }
          return { ..._pramotors, isFetchData: false };
        });
      const deletedpramotors = PromotersAndPartnersValues.promoters.filter(
        (_item) => !_item.isActive && _item.id
      );
      setContributorAndParnersValues({
        ...PromotersAndPartnersValues,
        promoters:
          partnersListing.email === ''
            ? [
                ...PromotersAndPartnersValues.promoters,
                {
                  ...values,
                  isActive: true,
                },
              ]
            : [...editpramotors, ...deletedpramotors],
      });
      handleClose();
    };

    const editCell = {
      header: '',
      renderEditDeleteCell: (
        row: PromotersAndPartnersType,
        index: number,
        _groupIndex?: number
      ): JSX.Element => {
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Tooltip aria-label="Edit Promoter/Partner" title="Edit Promoter/Partner">
              <IconButton
                onClick={() => {
                  const parnersForView = row.promoterdocuments.map((documentData) => {
                    if (documentData.documentId === documentData?.fileView?.id || '') {
                      return {
                        ...documentData,
                        file: documentData?.fileView,
                      };
                    } else {
                      return {
                        ...documentData,
                      };
                    }
                  });
                  setPartnersListing({
                    ...row,
                    promoterdocuments: parnersForView,
                  });

                  setRowIndex(index), setOpen(true);
                }}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}>
                <EditIcon sx={{ color: 'primary.main' }} fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip aria-label="Delete Promoter/Partner" title="Delete Promoter/Partner">
              <IconButton
                onClick={() => {
                  setPartnersListing(row), setRowIndex(index), setDeletePopup(true);
                }}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}>
                <DeleteOutlineIcon color="error" fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    };

    return (
      <>
        {PromotersAndPartnersValues.promoters.filter((_item) => _item.isActive).length !== 0 && (
          <Grid xs={12} sm={12} lg={12} mt={3}>
            <DataTable
              tableData={PromotersAndPartnersValues.promoters.filter((_item) => _item.isActive)}
              tableHeader={[
                ...partnersHeaders,
                ...viewPartnersDownloadCell(partnersListing?.promoterdocuments),
                editCell,
              ]}
              renderAdditionalRow={false}
              tableHeaderCustomStyles={{
                '.MuiTableCell-head': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'primary.main',
                },
              }}
              rowCustomStyles={{
                '.MuiTableCell-root': {
                  py: '8px',
                  overflowWrap: 'anywhere',
                },
              }}
              boxStyles={{ minHeight: '0px', minWidth: 450 }}
            />
          </Grid>
        )}
        <Grid
          xs={12}
          sm={12}
          lg={12}
          display="flex"
          sx={{
            justifyContent: {
              xs:
                PromotersAndPartnersValues.promoters.filter((_item) => _item.isActive).length === 0
                  ? 'start'
                  : 'center',
              sm:
                PromotersAndPartnersValues.promoters.filter((_item) => _item.isActive).length === 0
                  ? 'start'
                  : 'end',
            },
          }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{
              color: 'primary.main',
              fontWeight: 500,
              fontSize: 13,
              mr: 2.5,
              whiteSpace: 'nowrap',
              mt: '20px',
            }}
            onClick={() => {
              setPartnersListing(partnersListing), setOpen(true);
            }}>
            Add Promoters / Partners / Trustees
          </Button>

          <AccessibleDialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                px: 1,
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                position: 'sticky',
                top: 0,
                boxShadow: '0 2px #ccc 0.6',
                zIndex: 10,
                bgcolor: 'white',
                py: 3,
              }}>
              <Typography
                component="h3"
                sx={{
                  color: '#0D2762',
                  fontSize: '20px',
                  fontWeight: 500,
                  ml: { xs: 2, sm: 5 },
                }}>
                {partnersListing.id
                  ? 'Edit Promoters / Partners / Trustees'
                  : 'Add Promoters / Partners / Trustees'}
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '90%' },
                mx: 'auto',
                px: { xs: 3, sm: 0 },
                pb: 4,
              }}>
              <Formik
                initialValues={partnersListing}
                onSubmit={onSubmit}
                validate={(values: PromotersAndPartnersType) => {
                  const setValuesForEdit = contributorValuesAndParners.promoters
                    .filter((_item) => _item.isActive)
                    .map((_partners, index) => {
                      if (index === rowIndex) {
                        if (
                          values.pan !== _partners.pan &&
                          values.mobile !== _partners.mobile &&
                          values.email !== _partners.email
                        ) {
                          return _partners;
                        }
                        if (
                          values.pan === _partners.pan &&
                          values.mobile === _partners.mobile &&
                          values.email === _partners.email
                        ) {
                          const { mobile, email, pan, ...rest } = _partners;
                          return { ...rest };
                        }
                        if (
                          values.pan !== _partners.pan &&
                          values.mobile === _partners.mobile &&
                          values.email === _partners.email
                        ) {
                          const { mobile, email, ...rest } = _partners;
                          return { ...rest };
                        }
                        if (
                          values.pan === _partners.pan &&
                          values.mobile !== _partners.mobile &&
                          values.email === _partners.email
                        ) {
                          const { pan, email, ...rest } = _partners;
                          return { ...rest };
                        }
                        if (
                          values.pan === _partners.pan &&
                          values.mobile === _partners.mobile &&
                          values.email !== _partners.email
                        ) {
                          const { mobile, pan, ...rest } = _partners;
                          return { ...rest };
                        }
                        if (
                          values.pan !== _partners.pan &&
                          values.mobile !== _partners.mobile &&
                          values.email === _partners.email
                        ) {
                          const { email, ...rest } = _partners;
                          return { ...rest };
                        }
                        if (
                          values.pan !== _partners.pan &&
                          values.mobile === _partners.mobile &&
                          values.email !== _partners.email
                        ) {
                          const { mobile, ...rest } = _partners;
                          return { ...rest };
                        }
                        if (
                          values.pan === _partners.pan &&
                          values.mobile !== _partners.mobile &&
                          values.email !== _partners.email
                        ) {
                          const { pan, ...rest } = _partners;
                          return { ...rest };
                        }
                        return;
                      }
                      return _partners;
                    });
                  try {
                    validateYupSchema(
                      values,
                      nonIndividualParners(
                        nationalitiesMdmsResponse?.map((list) => {
                          return list?.name;
                        })
                      ),
                      true,
                      partnersListing.email
                        ? setValuesForEdit
                        : contributorValuesAndParners.promoters.filter((_item) => _item.isActive)
                    );
                  } catch (e) {
                    return yupToFormErrors(e);
                  }
                }}
                enableReinitialize={true}>
                {({ handleSubmit, setFieldValue, values, errors }) => (
                  <Grid
                    container
                    rowSpacing={1}
                    sx={{
                      width: '100%',
                      ml: 0,
                      '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                      mt: 1,
                    }}
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}>
                    <Grid item xs={12}>
                      <MFTextField name={`name`} label="Name *" placeholder="Enter Name" />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`pan`}
                        label="PAN *"
                        placeholder="Enter Pan"
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                        onChange={(e) => {
                          setFieldValue('pan', e.target.value.toUpperCase());
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <DatePicker
                        label={'Date of Birth *'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'rgba(0,0,0,0.7)',
                        }}
                        placeholder={'DD/MM/YYYY'}
                        name={`dateOfBirth`}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`mobile`}
                        label={`Mobile Number *`}
                        placeholder="Enter Mobile Number"
                        onKeyDown={(e) => {
                          preventSpecialCharacters(e);
                        }}
                        startAdornment={
                          <CountryCodesDropDown
                            name={`countryNameAndCode`}
                            value={values.countryNameAndCode}
                          />
                        }
                        regexForFilterValue={nonDigitRegex}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`email`}
                        label="Email ID (Office ID Only) *"
                        placeholder="Enter Email ID"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`designation`}
                        label="Designation *"
                        placeholder="Enter Designation"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`address1`}
                        label="Address Line - 1 *"
                        placeholder="Enter Address Line - 1"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`address2`}
                        label="Address Line - 2 *"
                        placeholder="Enter Address Line - 2"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <SearchableSelect
                        name={`country`}
                        label="Country *"
                        items={nationalitiesMdmsResponse.map((nationality) => ({
                          key: nationality.name,
                          value: nationality.name,
                        }))}
                        searchFieldPlaceholder={'Search Country'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MFTextField name={`state`} label="State *" placeholder="Enter State" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MFTextField name={`city`} label="City *" placeholder="Enter City" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MFTextField name={`pincode`} label="Pincode *" placeholder="Enter Pincode" />
                    </Grid>
                    <Grid item xs={12}>
                      {values.promoterdocuments.map((_partnersData, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Grid item>
                              <Typography
                                component="h3"
                                style={{
                                  color: 'rgba(0, 0, 0, 0.7)',
                                  fontWeight: 500,
                                  textAlign: 'left',
                                  fontSize: 14,
                                  marginBottom: 10,
                                }}>
                                {_partnersData.documentName}
                                {_partnersData.required === 'true' && ' *'}
                              </Typography>
                            </Grid>

                            <FileUpload
                              onFileChange={(
                                value,
                                documentId,
                                errorOnUpload,
                                removeFile,
                                result
                              ) => {
                                const { file, ...rest } = values.promoterdocuments[index];
                                setFieldValue(`promoterdocuments.${index}`, {
                                  ...rest,
                                  documentId,
                                  fileView: result,
                                  ...(!removeFile && { file: result?.id ? result : file }),
                                  errorOnUpload: errorOnUpload || false,
                                });
                              }}
                              documentData={{
                                ..._partnersData,
                                documentDetails: '',
                                documentId: _partnersData?.documentId || '',
                                isActive: true,
                                documentType: '',
                                documentName: '',
                                documentNumber: '',
                                documentExpiryDate: '',
                              }}
                              name={`promoterdocuments.${index}.documentId`}
                              displayReplaceButton={true}
                              errorTextAlign="flex-start"
                              fileValidateType={{
                                'image/jpeg': '.jpeg',
                                'image/jpg': '.jpg',
                                'image/png': '.png',
                              }}
                              supportTitle="jpeg, png, jpg"
                            />
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                    <Grid xs={12} sm={12} lg={12} display="flex" sx={{ justifyContent: 'center' }}>
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: 15,
                          minWidth: 180,
                          letterSpacing: 2,
                          fontWeight: 500,
                          alignSelf: 'center',
                          mt: 2,
                        }}
                        type="submit">
                        {partnersListing.email ? 'Save' : 'Add'}
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            </Box>
          </AccessibleDialog>
          <ConfirmationDialog
            message={'Are you sure you want to delete Promoters / Partners / Trustees ?'}
            open={deletePopup}
            setOpen={() => setDeletePopup(false)}
            onSave={() => {
              setDeletePopup(false);
              const deletePartners = contributorValuesAndParners.promoters
                .filter((_item) => _item.isActive)
                .map((_partners, _ind) => {
                  if (rowIndex === _ind) {
                    return { ..._partners, isActive: false };
                  }
                  return _partners;
                });
              const deletedPartners = contributorValuesAndParners.promoters.filter(
                (_item) => !_item.isActive && _item.id
              );
              const active_DeletedParners = deletePartners.filter(
                (_item) => _item.isActive || (!_item.isActive && _item.id)
              );
              setContributorAndParnersValues({
                ...contributorValuesAndParners,
                promoters: [...active_DeletedParners, ...deletedPartners],
              });
              setPartnersListing(partnersData);
              setRowIndex(Number);
            }}
            onCancel={() => {
              setPartnersListing(partnersData);
              setRowIndex(Number);
              setDeletePopup(false);
            }}
          />
        </Grid>
      </>
    );
  }
  return (
    <Formik
      initialValues={contributorValuesAndParners}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(
              shouldValidateUponSaveLater(values.saveType),
              application?.custodian || ''
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, errors }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.ckycNo`}
                    label="CKYC No./CKYC Acknowledge No./KIN No "
                    placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={(Object.keys(investorTypeMasterForCurrentCustodian) as string[]).map(
                      (investor) => ({
                        key: investorTypeMasterForCurrentCustodian[investor],
                        value: investor,
                      })
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label="PAN *"
                    placeholder="Enter PAN"
                    disabled={true}
                  />
                </Grid>
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income *"
                    items={(isCustodianICICI(application?.custodian || '')
                      ? grossAnnualIciciMasters
                      : grossAnnualMasters
                    )
                      ?.sort((income1, income2) => income1.min - income2.min)
                      .map((grossIncome) => ({
                        key: grossIncome.label,
                        value: grossIncome.label,
                      }))}
                    isSortingApplicable={false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="Net Worth *"
                    placeholder="Enter Net Worth"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography component="h3" sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth)}
                      </Typography>
                    )}
                </Grid>
              </React.Fragment>
            ))}
            {isHufType(values.applicants)
              ? checkIfApplicationIsNonIndividual(application as ApplicationProps) && (
                  <>
                    <SubHeading
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}>
                      List of Coparceners
                    </SubHeading>
                    <CoparceresDetails
                      coparcenersValues={values}
                      nationalitiesMdmsResponse={mdmsCountriesList}
                    />
                  </>
                )
              : checkIfApplicationIsNonIndividual(application as ApplicationProps) && (
                  <>
                    <SubHeading
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}>
                      Details of Promoters / Partners / Trustees and whole time Directors forming a
                      part of known Your Client (KYC)
                    </SubHeading>
                    <PromotersAndPartners
                      nationalitiesMdmsResponse={mdmsCountriesList}
                      PromotersAndPartnersValues={values}
                      pramotorsDocData={pramotorsDocData}
                    />
                  </>
                )}
            <FieldValidationNote />
            <ProceedSaveLater
              saveLater={() => {
                setTimeout(() => {
                  const firstErrorField = getFirstErrorField(errors);
                  scrollToFieldByName(firstErrorField || '');
                }, 0);
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setTimeout(() => {
                  const firstErrorField = getFirstErrorField(errors);
                  scrollToFieldByName(firstErrorField || '');
                }, 0);
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
          <AccessibleDialog
            open={validationDialog.open}
            onClose={() => setValidationDialog({ open: false, message: '' })}
            sx={{
              '& .MuiPaper-root': {
                minWidth: { xs: '300px', md: '400px' },
                maxWidth: { xs: '500px', md: '500px' },
                borderRadius: '8px',
                padding: '30px 30px 20px',
                color: '#4f4f4f',
              },
              '& .MuiDialogActions-root': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& .MuiButton-root': {
                  width: '160px',
                  height: '58px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '18px',
                  margin: 'auto',
                  marginBottom: '20px',
                },
              },
            }}>
            <DialogContent>
              <DialogContentText>
                <Typography
                  component="h3"
                  sx={{ textAlign: 'center', fontSize: 16, fontWeight: 500 }}>
                  {validationDialog.message}
                </Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setValidationDialog({ open: false, message: '' })}>
                OK
              </Button>
            </DialogActions>
          </AccessibleDialog>
        </>
      )}
    </Formik>
  );
}
